import {createSlice} from '@reduxjs/toolkit';
export const gradientColors = ['#5080d7', '#a26bfd'];
export const rgradientColors = ['#a26bfd', '#5080d7'];
export const Google_API_KEY = 'AIzaSyC3Cm6yRwDim-JnFWCGhsd2r1WvI-6n9f4';
const initialState = {
  isLoading: false,
  message: '',
};

const loader = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    showLoader(state, action) {
      state.isLoading = true;
      if (action.payload) {
        state.message = action.payload;
      }
    },
    hideLoader(state) {
      state.isLoading = false;
      state.message = '';
    },
  },
});

export const {showLoader, hideLoader} = loader.actions;

export default loader.reducer;
